import Icon from '@material-ui/core/Icon';
import React from 'react';

const PortalFontIcon = React.forwardRef(({name, theme, classes, ...props}:any, ref) => {
    return <Icon ref={ref} className={`notranslate ${name} ${props.className || ''}`} {...props}>{name}</Icon>
})

export default PortalFontIcon;